import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="container-x py-16 md:py-24">
      <div className="mb-16 max-w-2xl">
        <span className="section-eyebrow">Blog · Haberler</span>
        <h1 className="font-display text-5xl md:text-6xl mt-4 leading-tight">
          Muhasebe <span className="italic gold-gradient-text">gündemi</span>.
        </h1>
        <p className="mt-5 text-white/70">
          Güncel mevzuat, uygulamalı rehberler ve kariyerinize yön verecek içerikler.
        </p>
      </div>

      {posts.length === 0 ? (
        <div className="py-24 text-center text-white/50">Henüz yayınlanmış yazı yok.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`blog-card-${p.slug}`}
              className="card-hover bg-surface border border-white/10 overflow-hidden group"
            >
              <Link to={`/blog/${p.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-white/50 mb-3">
                    <Calendar className="w-3.5 h-3.5 text-gold" />
                    {new Date(p.created_at).toLocaleDateString("tr-TR")}
                    {p.tags?.[0] && (
                      <>
                        <span>·</span>
                        <span className="text-gold uppercase tracking-widest">{p.tags[0]}</span>
                      </>
                    )}
                  </div>
                  <h2 className="font-display text-2xl leading-tight group-hover:text-gold transition-colors">{p.title}</h2>
                  <p className="text-sm text-white/60 mt-3 line-clamp-3">{p.excerpt}</p>
                  <div className="mt-5 text-xs uppercase tracking-widest text-gold flex items-center gap-2">
                    Devamını Oku <ArrowRight className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      )}
    </div>
  );
}
